import React, { useCallback } from 'react'
import { func, shape, string } from 'prop-types'
import { useOverlay } from '@fs/zion-ui'
import { EditGroupOverlay } from '@fs/zion-group-management'
import { trackEvent } from '@fs/zion-analytics'
import ButtonCard from './ButtonCard'
import { useGetGroup } from '../../hooks'

const cardContentProps = {
  headingFallback: 'Enable shared living memories',
  headingKey: 'create-family-group-prompt.enable-living-memories',
  buttonFallback: 'Edit Group Settings',
  buttonKey: 'familygroups.card.enableGroupTree.button',
  descriptionFallback:
    'Your current Family Group does not currently allow for shared living memories. <strong>You can enable this feature in the group settings.</strong>',
  descriptionKey: 'familygroups.card.enableGroupTree.description',
}

export default function EditGroupCard({ refreshGroups, familyGroup }) {
  const editGroupOverlay = useOverlay()
  const {
    query: { data: familyGroupData, refetch },
  } = useGetGroup(familyGroup.id)

  const updateCard = useCallback(() => {
    refreshGroups()
    refetch()
  }, [refetch, refreshGroups])

  const onClick = useCallback(() => {
    trackEvent({ event_name: 'EditGroupCard:EDIT_GROUP_SETTINGS:CLICK', familyGroupId: familyGroup.id })
    editGroupOverlay.handleClick()
  }, [editGroupOverlay, familyGroup.id])

  return (
    <ButtonCard buttonProps={{ onClick }} {...cardContentProps}>
      <EditGroupOverlay overlay={editGroupOverlay} groupDetails={familyGroupData} onEditGroup={updateCard} />
    </ButtonCard>
  )
}

EditGroupCard.propTypes = {
  refreshGroups: func.isRequired,
  familyGroup: shape({
    id: string.isRequired,
  }),
}
